import React from "react";
import GestureToSpeech from "../components/WebDemo/GestureToSpeech";
import SpeechToGesture from "../components/WebDemo/SpeechToGesture";
import "../styles/webdemo.css";

const WebDemo = () => {
    const [mode, setMode] = React.useState("gestureToSpeech"); // default mode

    return (
        <div className="web-demo-container">
            {mode === "gestureToSpeech" ? (
                <GestureToSpeech setMode={setMode} />
            ) : (
                <SpeechToGesture setMode={setMode} />
            )}
        </div>
    );
};

export default WebDemo;